import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from '../gsap-club/gsap-business-green/src/CustomEase';
import { SplitText } from '../gsap-club/gsap-business-green/src/SplitText';
gsap.registerPlugin( ScrollTrigger, CustomEase, SplitText );

/* eslint-disable */
( function () {
	let mm = gsap.matchMedia();

	mm.add( {
		isMin0: '(min-width: 0px)',
		isMin1024: '(min-width: 1024px)',
		reduceMotion: '(prefers-reduced-motion: reduce)',
	},
	( context ) => {
		// context.conditions has a boolean property for each condition defined above indicating if it's matched or not.
		let { isMin0, isMin1024, reduceMotion } = context.conditions;
		const scrollText = document.querySelectorAll( '.scroll-text' );
		
		scrollText.forEach( (item, index) => {
			const suppressPin = item.classList.contains('scroll-text--pin-false');

			/**IF desktop and suppress pin is false, pin animation ELSE animate on entry**/
			if (isMin1024) {
				
				const tl = gsap.timeline( { paused: true } );
				const text = item.querySelector( '.scroll-text__headline' );
				const splitText = new SplitText( text, {type: "chars, words", charsClass: "char char++"} );

				if (suppressPin) {
					tl.to('.char', {
						color: 'rgba(0, 0, 0, 1)',
						stagger: 0.005,
					});
					// create the ScrollTrigger instance
					const trigger = ScrollTrigger.create( {
						animation: tl,
						trigger: item,
						start: 'top bottom',
						end: 'top top',
						pin: false,
						scrub: 0.25,
					} );

				} else {
					tl.to('.char', {
						color: 'rgba(0, 0, 0, 1)',
						stagger: 0.02,
						duration: 0.02
					});

					// create the ScrollTrigger instance
					const trigger = ScrollTrigger.create( {
						animation: tl,
						trigger: item,
						start: 'center center',
						pinnedContainer: item,
						end: "+=200%",
						pin: true,
						scrub: 0.25,
					} );
				}
				
			} else {
				
				const tl = gsap.timeline( { paused: true } );
				const text = item.querySelector( '.scroll-text__headline' );
				const splitText = new SplitText( text, {type: "chars, words", charsClass: "char char++"} );

				tl.to('.char', {
					color: 'rgba(0, 0, 0, 1)',
					stagger: 0.015,
					duration: 0.25,
				});

				// create the ScrollTrigger instance
				const trigger = ScrollTrigger.create( {
					animation: tl,
					trigger: item,
					start: 'top 70%',
					pin: false,
					once: true,
				} );

			}
		})
	});
} )();
/* eslint-enable */
